import { useState } from 'react';
import { motion } from 'framer-motion';
import SectionHeader from '../ui/SectionHeader';
import MotionReveal from '../ui/MotionReveal';
import SingleProject from '../SingleProject/SingleProject';
import FeaturedBento from './FeaturedBento';
import { projects } from '../../data/projectsData';
import { sectionCopy } from '../../data/portfolioData';

const categories = ['All', 'Web Development', 'E-commerce'];

const ProjectsSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const copy = sectionCopy.projects;

  const filteredProjects =
    selectedCategory === 'All' ? projects : projects.filter((p) => p.category === selectedCategory);

  return (
    <section id="projects" className="section-padding bg-ant-bg-2 text-ant-fg border-t border-ant-line-soft">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          label={copy.label}
          titleLine1={copy.titleLine1}
          titleLine2={copy.titleLine2}
          subtitle={copy.subtitle}
          align="center"
          className="text-center mx-auto"
        />

        {selectedCategory === 'All' && <FeaturedBento />}

        <MotionReveal delay={80} className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-10 sm:mb-12">
          {categories.map((category) => (
            <motion.button
              key={category}
              onClick={() => setSelectedCategory(category)}
              whileTap={{ scale: 0.97 }}
              className={`px-4 sm:px-6 py-2.5 sm:py-3 rounded-full font-medium text-xs sm:text-sm transition-all duration-300 min-h-[44px] ${
                selectedCategory === category
                  ? 'bg-white text-ant-bg-2'
                  : 'border border-white/10 text-white/45 hover:text-white hover:border-white/25'
              }`}
            >
              {category}
            </motion.button>
          ))}
        </MotionReveal>

        <motion.div
          layout
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6"
        >
          {filteredProjects.map((project, index) => (
            <MotionReveal key={project.id} delay={(index % 3) * 100} variant="scale">
              <SingleProject
                {...project}
                badge={
                  <span
                    className={`whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${
                      project.status === 'Completed'
                        ? 'bg-ant-green/10 text-ant-green border border-ant-green/20'
                        : 'bg-ant-gold/10 text-ant-gold border border-ant-gold/20'
                    }`}
                  >
                    {project.status}
                  </span>
                }
              />
            </MotionReveal>
          ))}
        </motion.div>

        {filteredProjects.length === 0 && (
          <p className="text-center text-white/40 py-12">{copy.emptyState}</p>
        )}
      </div>
    </section>
  );
};

export default ProjectsSection;